import Chart from 'react-apexcharts';
import styled from 'styled-components';

const ChartBuilderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-right: 20px;

  @media (min-width: 1024px) {
    margin-bottom: unset;
  }
`;

const ChartWrapper = styled.div`
  .apexcharts-title-text {
    font-size: 12px;
  }

  @media (min-width: 1024px) {
    .apexcharts-title-text {
      font-size: 14px;
    }
  }
`;

const ChartBuilder = ({ options, series, type, width, height = 'auto' }) => {
  return (
    <ChartBuilderWrapper className="chart_builder_wrapper">
      <ChartWrapper>
        <Chart options={options} series={series} type={type} width={width} height={height} />
      </ChartWrapper>
    </ChartBuilderWrapper>
  );
};

export default ChartBuilder;
